var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 11.9599L9.3125 14.2839L14.6562 9.05492M20 12.5409C20 18.2444 13.6421 22.3927 11.3289 23.7132C11.066 23.8634 10.9345 23.9384 10.749 23.9773C10.605 24.0076 10.395 24.0076 10.251 23.9773C10.0655 23.9384 9.93404 23.8634 9.67112 23.7132C7.35783 22.3927 1 18.2444 1 12.5409V6.98379C1 6.05476 1 5.59025 1.15528 5.19095C1.29245 4.83822 1.51535 4.52348 1.80472 4.27394C2.13228 3.99148 2.57676 3.82838 3.46572 3.50217L9.83286 1.16578C10.0797 1.0752 10.2031 1.0299 10.3302 1.01195C10.4428 0.996017 10.5572 0.996017 10.6698 1.01195C10.7969 1.0299 10.9203 1.0752 11.1671 1.16578L17.5343 3.50217C18.4232 3.82838 18.8677 3.99148 19.1952 4.27394C19.4846 4.52348 19.7075 4.83822 19.8447 5.19095C20 5.59025 20 6.05476 20 6.98379V12.5409Z",
    stroke: "#87DDA4",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuard2);
export default __webpack_public_path__ + "static/media/Guard2.72672b0c1cae578245c1c4c707bc33b5.svg";
export { ForwardRef as ReactComponent };